
export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-[#F8EDEA]">
      {/* Hero Section */}
      <section 
        className="py-16 relative"
        style={{
          backgroundImage: `linear-gradient(rgba(248,237,234,0.9), rgba(248,237,234,0.9)), url('https://static.readdy.ai/image/fd456b0d540e8f517714341c204b3126/e5a40b4f7b52fcfa548a8f38ffe25152.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-16 h-16 bg-[#B97A72] rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-file-text-line text-3xl text-white"></i>
          </div>
          <h1 className="text-6xl font-bold text-[#B97A72] mb-6" style={{ fontFamily: 'Allura, cursive' }}>
            Mentions légales & Confidentialité
          </h1>
          <p className="text-xl text-[#6B5E5A] max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Informations légales et politique de confidentialité des Carnets de Lolotte.
            Transparence et respect de vos données personnelles.
          </p>
        </div>
      </section>

      {/* Contenu principal */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Section 1: Mentions légales */}
          <div className="bg-[#FAF9F8] rounded-lg border-2 border-[#B97A72] p-8 mb-12">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-[#B97A72] rounded-full flex items-center justify-center mr-4">
                <i className="ri-building-line text-xl text-white"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#B97A72]" style={{ fontFamily: 'Allura, cursive' }}>
                📍 Mentions légales
              </h2>
            </div>
            <div className="space-y-4 text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <p className="text-lg font-semibold mb-2">Nom de l'entreprise :</p>
                  <p className="text-lg">Les Carnets de Lolotte</p>
                </div>
                <div>
                  <p className="text-lg font-semibold mb-2">Statut :</p>
                  <p className="text-lg">Entreprise individuelle / Micro-entreprise</p>
                </div>
                <div>
                  <p className="text-lg font-semibold mb-2">Gérante :</p>
                  <p className="text-lg">Nathalie Savona</p>
                </div>
                <div>
                  <p className="text-lg font-semibold mb-2">Siège social :</p>
                  <p className="text-lg">Draguignan Var, France)</p>
                </div>
                <div>
                  <p className="text-lg font-semibold mb-2">SIRET :</p>
                  <p className="text-lg">88037569600023</p>
                </div>
                <div>
                  <p className="text-lg font-semibold mb-2">Contact :</p>
                  <p className="text-lg">contact@lescarnetsdelolotte.com</p>
                </div>
              </div>
              <div className="mt-6">
                <p className="text-lg font-semibold mb-2">Contact :</p>
                <p className="text-lg">contact@lescarnetsdelolotte.com</p>
              </div>
              <div className="mt-6">
                <p className="text-lg font-semibold mb-2">Propriété intellectuelle :</p>
                <p className="text-lg leading-relaxed">
                  L'ensemble du contenu du site (textes, images, photos, créations, logos, graphismes…) est la propriété exclusive de <em>Les Carnets de Lolotte</em>.
                  Toute reproduction, diffusion ou utilisation sans autorisation est interdite.
                </p>
              </div>
            </div>
          </div>

          {/* Section 2: Vente en ligne et paiement */}
          <div className="bg-[#FAF9F8] rounded-lg border-2 border-[#B97A72] p-8 mb-12">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg[#B97A72] rounded-full flex items-center justify-center mr-4">
                <i className="ri-bank-card-line text-xl text-white"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#B97A72]" style={{ fontFamily: 'Allura, cursive' }}>
                💳 Vente en ligne et paiement
              </h2>
            </div>
            <div className="space-y-4 text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
              <p className="text-lg leading-relaxed">
                Les paiements effectués sur le site <em>Les Carnets de Lolotte</em> sont gérés par la plateforme <strong>Stripe</strong>, prestataire de paiement sécurisé.
              </p>
              <p className="text-lg leading-relaxed">
                Aucune donnée bancaire n'est enregistrée sur le site.
                Lestransactions sont cryptées et protégées conformément aux normes <strong>PCI DSS</strong>.
              </p>
            </div>
          </div>

          {/* Section 3: Politique de confidentialité */}
          <div className="bg-[#FAF9F8] rounded-lg border-2 border-[#B97A72] p-8 mb-12">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-[#B97A72] rounded-full flex items-center justify-center mr-4">
                <i className="ri-shield-user-line text-xl text-white"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#B97A72]" style={{ fontFamily: 'Allura, cursive' }}>
                🌿 Politique de confidentialité (RGPD)
              </h2>
            </div>
            
            {/* Collecte des données */}
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-[#B97A72] mb-4" style={{ fontFamily: 'Allura, cursive' }}>
                Collecte des données
              </h3>
              <div className="space-y-4 text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                <p className="text-lg leading-relaxed">
                  Les Carnets de Lolotte collecte uniquement les informations nécessaires au traitement des commandes :
                </p>
                <ul className="list-disc list-inside space-y-2 text-lg ml-4">
                  <li>Nom et prénom</li>
                  <li>Adresse postale</li>
                  <li>Adresse e-mail</li>
                  <li>Téléphone (facultatif)</li>
                  <li>Informations de livraison et de paiement (non stockées sur le site)</li>
                </ul>
                <p className="text-lg leading-relaxed mt-4">
                  Ces données sont utilisées exclusivement pour :
                </p>
                <ul className="list-disc list-inside space-y-2 text-lg ml-4">
                  <li>la préparation et l'expédition des commandes,</li>
                  <li>la communication avec les clients,</li>
                  <li>les obligations légales et comptables.</li>
                </ul>
              </div>
            </div>

            {/* Conservation des données */}
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-[#B97A72] mb-4" style={{ fontFamily: 'Allura, cursive' }}>
                Conservation des données
              </h3>
              <div className="space-y-4 text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                <p className="text-lg leading-relaxed">
                  Les données clients sont conservées pendant la durée légale nécessaire à la gestion administrative et comptable (généralement 3 ans après la dernière commande).
                </p>
                <p className="text-lg leading-relaxed">
                  Vous pouvez à tout moment demander la <strong>modification ou la suppression</strong> de vos données personnelles en écrivant à :
                  <br />📧 contact@lescarnetsdelolotte.com
                </p>
              </div>
            </div>

            {/* Cookies et statistiques */}
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-[#B97A72] mb-4" style={{ fontFamily: 'Allura, cursive' }}>
                Cookies et statistiques
              </h3>
              <div className="space-y-4 text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                <p className="text-lg leading-relaxed">
                  Le site utilise uniquement des cookies techniques nécessaires à son bon fonctionnement.
                  Aucun cookie publicitaire ou de traçage externe n'est utilisé.
                </p>
                <p className="text-lg leading-relaxed">
                  Des statistiques anonymes peuvent être collectées pour améliorer l'expérience utilisateur.
                </p>
              </div>
            </div>

            {/* Droit d'accès */}
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-[#B97A72] mb-4" style={{ fontFamily: 'Allura, cursive' }}>
                Droit d'accès et de rectification
              </h3>
              <div className="space-y-4 text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                <p className="text-lg leading-relaxed">
                  Conformément à la loi Informatique et Libertés et au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles.
                </p>
                <p className="text-lg leading-relaxed">
                  Pour toute demande, contactez :
                  <br />📧 contact@lescarnetsdelolotte.com
                </p>
              </div>
            </div>
          </div>

          {/* Section 4: Responsabilité */}
          <div className="bg-[#FAF9F8] rounded-lg border-2 border-[#B97A72] p-8 mb-12">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-[#B97A72] rounded-full flex items-center justify-center mr-4">
                <i className="ri-information-line text-xl text-white"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#B97A72]" style={{ fontFamily: 'Allura, cursive' }}>
                ⚖️ Responsabilité
              </h2>
            </div>
            <div className="space-y-4 text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
              <p className="text-lg leading-relaxed">
                Les Carnets de Lolotte s'efforce d'assurer la fiabilité et la mise à jour des informations présentes sur le site.
                Cependant, des erreurs ou omissions peuvent survenir.
              </p>
              <p className="text-lg leading-relaxed">
                L'entreprise ne saurait être tenue responsable de l'utilisation faite du contenu du site ou d'éventuels dommages directs ou indirects liés à son utilisation.
              </p>
            </div>
          </div>

          {/* Dernière mise à jour */}
          <div className="text-center mb-12">
            <div className="bg-[#B97A72] text-white rounded-lg p-6">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-line text-2xl text-white"></i>
              </div>
              <p className="text-lg font-semibold" style={{ fontFamily: 'Poppins, sans-serif' }}>
                📎 Dernière mise à jour : Octobre 2025
              </p>
            </div>
          </div>

          {/* Message final */}
          <div className="text-center p-8">
            <p className="text-xl text-[#C49B86] italic leading-relaxed" style={{ fontFamily: 'Playfair Display, serif' }}>
              💕 <em>Merci de votre confiance envers Les Carnets de Lolotte.</em><br/>
              <em>Nous nous engageons à respecter et protéger vos données personnelles.</em>
            </p>
          </div>

        </div>
      </section>
    </div>
  );
}